import { Box } from '@mui/material';
import React, { } from 'react';
import OutfitsHome from './outfits/OutfitsHome';


const Home = () => {

  return (
    <Box sx={{ width: '100%' }}>
      <OutfitsHome />
    </Box>
  );
}

export default Home;
